<template>
    <section id="page-lesbevoegdheid" class="page page-lesbevoegdheid">
        <div class="page__content">
            <div class="page__icon-wrapper"><i class="fa fa-university" aria-hidden="true"></i></div>
            <div class="container list-select">
                <h1>HET HEBBEN VAN EEN LESBEVOEGDHEID VERGROOT JOUW MOGELIJKHEDEN OM ALS HYBRIDE DOCENT AAN DE SLAG TE GAAN</h1>
                <div class="row">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm list-select__title">Ben je in het bezit van een lesbevoegdheid?</div>
                </div>
                <div class="list-select__item row"
                     v-bind:class="{'list-select__item--selected': userProfile.bevoegdheid === true}"
                     @click="setLesbevoegdheid(true)">
                    <div class="col-2-sm list-select__item-marker-column">
                        <div class="list-select__item-marker"></div>
                    </div>
                    <div class="col-10-sm list-select__item-text">
                        <p>Ja</p>
                    </div>
                </div>
                <div class="list-select__item row"
                     v-bind:class="{'list-select__item--selected': userProfile.bevoegdheid === false}"
                     @click="setLesbevoegdheid(false)">
                    <div class="col-2-sm list-select__item-marker-column">
                        <div class="list-select__item-marker"></div>
                    </div>
                    <div class="col-10-sm list-select__item-text">
                        <p>Nee</p>
                    </div>
                </div>
            </div>

            <div class="container" v-if="bevoegdheidEntered">
                <div class="row">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm">
                        <button class="button" v-on:click="submitBevoegdheid()">Volgende</button>
                    </div>
                </div>
            </div>
            <!-- Some line breaks to make sure we have enough vertical space for the typeahead popup -->
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>

    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-aanvragen__aanvraagformulier
        font-family $font-secondary
    .page-aanvragen__aanvraagformulier-chk
        text-align right

    .page-aanvragen__aanvraagformulier-chk-label
        text-align left



</style>
<script>
    import typeahead from "../../components/typeahead/typeahead.vue";
    import page from './page';

    export default {
        mixins: [page],
        props: {
            userProfile: {
                type: Object,
                default: {}
            },
            vakken: {
                type: Array,
                default: []
            }
        },
        computed: {
            bevoegdheidEntered() {
                return this.userProfile.bevoegdheid !== null;
            }
        },
        methods: {
            setLesbevoegdheid(heeftBevoegdheid) {
                this.$emit('profileupdate', { key: 'bevoegdheid', value: heeftBevoegdheid });
            },
            selectVak(vak) {
                this.$emit('profileupdate', { key: 'bevoegdheidIn', value: vak });
            },
            submitBevoegdheid() {
                this.nextHandler();
            }
        },
        components: {
            typeahead
        }

    }
</script>



// WEBPACK FOOTER //
// page-lesbevoegdheid.vue?2a59b87e